import React, { useCallback, useReducer } from 'react';

import { baseReducer } from './baseReducer';
import { IAction, IContext } from './consts';

export const ScreenContext = React.createContext({
  state: null,
  dispatch: () => {},
} as IContext);

export const ScreenProvider = ({
  children,
  screenReducer,
  initialState = {},
}: any) => {
  const reducer = useCallback(
    (state: any, action: IAction) => {
      const state1 = baseReducer(state, action);
      if (screenReducer) {
        return screenReducer(state1, action);
      }
      return screenReducer(state1, action);
    },
    [screenReducer, baseReducer]
  );

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ScreenContext.Provider value={{ state, dispatch }}>
      {children}
    </ScreenContext.Provider>
  );
};
